import React from "react";
import { Route } from "react-router-dom";

const PrivateRoute = ({
  componentRef,
  component: Component,
  exact,
  strict,
  path,
  routeRender,
  ...rest
}) => (
  <Route
    exact={exact}
    strict={strict}
    path={path}
    render={props =>
      routeRender ? (
        routeRender(props)
      ) : (
        <Component ref={componentRef} {...props} {...rest} />
      )
    }
  />
);

export default PrivateRoute;
